import $ from 'jquery';

$(document).ready(() => {
  if (window.location.hash) {
    const preAnchor = window.location.hash.substr(1);
    $('html, body').scrollTop(0);

    setTimeout(() => {
      const attrName = $(`a[name="${preAnchor}"]`);
      $('html,body').animate({
        scrollTop: attrName.offset().top,
      }, 500);
    }, 200);
  }

  $('.js-scroll').click((event) => {
    if ($('.home-page').length) {
      event.preventDefault();
    }

    const anchor = $(event.currentTarget).attr('data-attr-scroll');
    const anchorOffset = 0;

    if (!anchorOffset) {
      const attrName = $(`a[name="${anchor}"]`);
      $('html,body').animate({
        scrollTop: attrName.offset().top,
      }, 500);
    }
  });
});



// WEBPACK FOOTER //
// ./js/components/init-scroll-section.js